import { useCallback, useEffect } from 'react';

const useDebounced = (effect: () => unknown, delay: number, deps: unknown[]): void => {
	const callback = useCallback(effect, deps);

	useEffect(() => {
		const handler = setTimeout(() => {
			callback();
		}, delay);

		return (): void => {
			clearTimeout(handler);
		};
	}, [callback, delay]);
};

export default useDebounced;
